import React, { Component, Fragment } from 'react';
import {
  Row,
  Card,
  CardBody,
  Input,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  DropdownItem,
} from 'reactstrap';
import { connect } from 'react-redux';
import moment from 'moment';
import {
  gAPI_QuickReplies,
  gAPI_FormsCategoryList,
} from '../../../../../constants/APIs';
import {
  getChatList,
  getChatListSearch,
  getChat,
  getPropertyList,
  createTicket,
} from '../../../../../redux/actions';
import { injectIntl } from 'react-intl';
import 'moment-timezone';
import bot_icon from './../../../../../assets/bot_icon.png';
import Validation from '../../../../../components/Validation';
import Archives from '../../conversations/components/Archives';
import ChatMessage from '../../../../../components/chats/ChatMessage';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import Pagination from '../../../../../containers/pages/Pagination';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import no_contact_conversations from './../../../../../assets/no_contact_conversations.png';
const pageSizes = [2, 10, 15, 20, 25];
class Conversations extends Component {
  constructor(props) {
    super(props);
    this._scrollBarRef1 = React.createRef();
    this.state = {
      startDate: moment().subtract(
        this.props.location !== undefined &&
          this.props.location.state !== undefined &&
          this.props.location.state.date != undefined
          ? this.props.location.state.date
          : 2,
        'days'
      ),
      endDate: moment(),
      hotel: {},
      embeddedDate: moment(),
      items: 50,
      currentPage: 1,
      SelectedPageSize: 2,
      code: {},
      offset: 0,
      loading: false,
      data: [],
      activeIndex: -1,
      ticketTitle: '',
      ticketComments: '',
      ticketAssignTo: '',
      ticketCategory: '',
      ticketSelectedCategory: [],
      ticketSelectedStatus: [],
      ticketType: null,
      ticketPriority: null,
      popupProperty: null,
      isVisibleTicketBtn: false,
      selectedChat: null,
      isLoading: false,
      isLoadmore: true,
      showLoadMoreBtn: false,
      isFiltering: false,
      showTwilioConversationList: false,
      twilioToken: '',
      transfertobot: false,
      transfertomesseger: false,
      facebookSenderName: '',
      recordingurl: '',
      transcript: '',
      channel: 'All',
      open: false,
      msg: [],
      quickReplyTemplates: [],
      statusmodal: false,
      cstatus: 'Opened',
      filterstatus: 'Opened',
      googleSenderName: '',
      whatsAppSenderPhoneNumber: '',
      feedback: 'all',
      isMasked:
        sessionStorage.getItem('lock') === null
          ? 'false'
          : sessionStorage.getItem('lock'),
      selectedTopic: {},
      selectedCountry: [],
      missedResponseTitle: '',
      ticketStatus: null,
      isFilterGet: false,
      categoryList: [],
      type:
        this.props.location !== undefined &&
        this.props.location.state !== undefined &&
        this.props.location.state.tagName != undefined
          ? this.props.location.state.tagName
          : undefined,
      // data: this.props.getChatList({pid:'0b999af2-e798-49ae-bac6-b00559fde7d0',items:10,offset:0})
      channelName:
        this.props.location !== undefined &&
        this.props.location.state !== undefined &&
        this.props.location.state.channelName != undefined
          ? this.props.location.state.channelName
          : undefined,
    };
    this.audio = new Audio(
      'https://bmbuiassetsprod.blob.core.windows.net/images/chat_notification.mp3'
    );
  }
  componentDidUpdate(prevProps) {
    if (
      this.props.location !== undefined &&
      this.props.location.state !== undefined &&
      this.props.location.state.tagName != undefined &&
      (prevProps.location.state === undefined ||
        this.props.location.state.tagName !== prevProps.location.state.tagName)
    ) {
      this.setState({
        type: this.props.location.state.tagName,
      });
    }
  }
  componentDidMount() {
    let channelName = '';
    if (this.state.channelName !== undefined) {
      if (this.state.channelName === 'websiteConversation') {
        channelName = 'WebsiteDirectLine';
      } else if (this.state.channelName === 'facebookConversation') {
        channelName = 'FacebookDirectLine';
      } else if (this.state.channelName === 'googleMapsConversation') {
        channelName = 'GoogleBusinessMessage';
      } else if (this.state.channelName === 'whatsappConversation') {
        channelName = 'WhatsApp';
      } else if (this.state.channelName === 'EmailDirectLine') {
        channelName = 'EmailDirectLine';
      } else if (this.state.channelName === 'PhoneSuite') {
        channelName = 'PhoneSuite';
      } else if (this.state.channelName === 'Instagram') {
        channelName = 'Instagram';
      } else if (this.state.channelName === 'TeamsApp') {
        channelName = 'TeamsApp';
      }
      this.setState({ channel: channelName });
    } else {
      channelName = 'All';
    }
    //console.log(this.props.timeZone)
    //console.log(this.props.propertyId)
    moment.tz.setDefault(this.props.timeZone);
    this.setState({ isLoading: true });
    this.props.getPropertyList();
    if (this.props?.conversations) {
      this.setState((state) => ({
        data: this.props.conversations,
        items: this.props.pageSize,
        offset: this.props.pageCount,
        isLoading: false,
      }));
      let data = this.props.conversations;
      if (data.length > 0) {
        this.setState({ activeIndex: 0, isVisibleTicketBtn: true });
        this.props.getChat(data[0].conversationId);
      }
    }
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_FormsCategoryList}?groupId=${getGroupID()}&propertyId=${
        this.props.propertyId
      }&lang=${this.props.locale}`,
    }).then((res) => {
      var category = [];
      res.data.map((l) => category.push(l));
      this.setState({ categoryList: category });
    });

    this.loadQuickTemmplates();
  }
  componentWillReceiveProps(props) {
    if (
      props.chatListApp.selectedchat !== this.props.chatListApp.selectedchat
    ) {
      this.setState({
        selectedChat: props.chatListApp.selectedchat,
        cstatus: props.chatListApp.selectedchat.status,
      });
    }

    if (this.props?.conversations && this.state.data.length === 0) {
      this.setState((state) => ({
        data: this.props.conversations,
        items: this.props.pageSize,
        offset: this.props.pageCount,
        isLoading: false,
      }));
      let data = this.props.conversations;
      if (data.length > 0) {
        this.setState({ activeIndex: 0, isVisibleTicketBtn: true });
        this.props.getChat(data[0].conversationId);
      }
    }
  }
  loadQuickTemmplates = () => {
    if (this.props.propertyId != '-1') {
      AxiosAPI({
        methhod: 'get',
        url: `${gAPI_QuickReplies}?groupId=${getGroupID()}&propertyId=${
          this.props.propertyId
        }&locale=${this.props.locale}`,
      }).then(
        (res) => {
          this.setState((state) => ({
            quickReplyTemplates: res.data,
          }));
        },
        (error) => {
          this.setState({ loading: false, error, isLoading: false });
        }
      );
    }
  };
  handleMaskClick = () => {
    if (sessionStorage.getItem('lock') === 'true') {
      sessionStorage.setItem('lock', 'false');
      this.setState({ isMasked: 'false' });
    } else {
      sessionStorage.setItem('lock', 'true');
      this.setState({ isMasked: 'true' });
    }
  };
  handleContactClick = (index, userId) => {
    this.setState({ activeIndex: index, isVisibleTicketBtn: true });
    const chat = this.props.getChat(userId);
  };

  loadMoreConversations = () => {
    this.props.handleConversations('', 50);
  };

  handleStatus = (category) => {
    var cate = [];
    cate.push(category);
    this.setState({
      ticketStatus: category.value,
      ticketSelectedStatus: cate,
    });
  };
  statustoggle = () => {
    this.setState((prevState) => ({
      statusmodal: !prevState.statusmodal,
    }));
  };

  toggle = () => {
    var selectedProperty =
      this.props.usersListApp.properties !== undefined
        ? this.props.usersListApp.properties
            .filter((elem) => elem.id === this.props.propertyId)
            .map((pro) => {
              return { label: pro.name, value: pro.id };
            })[0]
        : null;
    this.setState((prevState) => ({
      modal: !prevState.modal,
      ticketStatus: 'Pending',
      ticketSelectedStatus: [{ label: 'Assigned', value: 'Pending' }],
      popupProperty: selectedProperty,
    }));
  };

  toggleMessanger = () => {
    this.setState((prevState) => ({
      transfertomesseger: !prevState.transfertomesseger,
    }));
  };

  togglebot = () => {
    this.setState((prevState) => ({
      transfertobot: !prevState.transfertobot,
    }));
  };

  onChangePage = (page) => {
    this.setState({ currentPage: page });
    this.props.handleConversations('', 50, page);
  };

  changeIntegration = (e) => {
    this.setState({ data: [] });
    this.props.handleConversations(e.target.value, 0, 0);
  };

  render() {
    const {
      usersListApp: { properties },
    } = this.props;
    const { selectedChat } = this.state;

    return (
      <Fragment>
        <div
        // style={{ marginLeft: '-3%', marginRight: '-3%', marginTop: '-0.75%' }}
        >
          <Row>
            <Colxx xxs="12" md="6" className="mb-2 col-sm-12 col-md-6">
              <Card className="cardHeight conversation-height">
                <CardBody className="mt-0">
                  <Row>
                    <Colxx xxs="6" className="mb-3 text-right"></Colxx>
                    <Colxx xxs="6" className="mb-3 text-right">
                      <Input
                        type="select"
                        value={this.props?.selectedIntegration}
                        name="type"
                        onChange={(e) => this.changeIntegration(e)}
                      >
                        <option value="WebsiteDirectLine">Website</option>
                        <option value="FacebookDirectLine">Facebook</option>
                        <option value="WhatsApp">WhatsApp</option>
                        <option value="EmailDirectLine">Email</option>
                        <option value="PhoneSuite">Voice</option>
                        <option value="Instagram">Instagram</option>
                        <option value="TeamsApp">TeamsApp</option>
                      </Input>
                    </Colxx>
                  </Row>
                    {this.state.data !== undefined &&
                    this.state.data.length > 0 ? (
                      <Archives
                        startDate={this.state.startDate}
                        endDate={this.state.endDate}
                        offset={this.state.offset}
                        items={this.state.items}
                        isLoading={this.state.isLoading}
                        data={this.state.data}
                        isContact={true}
                        activeIndex={this.state.activeIndex}
                        pid={this.props.propertyId}
                        handleContactClick={this.handleContactClick}
                        loadMoreConversations={this.loadMoreConversations}
                        handleMaskClick={this.handleMaskClick}
                        isMasked={this.state.isMasked}
                        properties={properties}
                      />
                    ) : (
                      <Card className=" archive-card" style={{ display: 'flex', height: '76vh', alignItems: 'center', justifyContent: 'center' }}>
                        <img
                          src={no_contact_conversations}
                          alt="No Conversations"
                          style={{ width: '60%' }}
                        />
                      </Card>
                    )}
                </CardBody>
              </Card>
            </Colxx>
            <Colxx xxs="12" md="6" className="mb-2 col-sm-12 col-md-6 pl-0">
              {/* <CardTitle>Chat</CardTitle>{' '} */}
              <Card
                className="cardHeight conversation-height archive-card"
                style={{
                  overflow: 'scroll',
                  backgroundColor: selectedChat
                    ? `${selectedChat.colours.botBackground}`
                    : '#fff',
                  scrollbarColor: `darkgrey ${
                    selectedChat ? selectedChat.colours.botBackground : '#fff'
                  }`,
                }}
              >
                <CardBody>
                  <div className="scroll  ">
                    {selectedChat ? (
                      <div>
                        {selectedChat.messages != null &&
                          selectedChat.messages.length > 0 &&
                          selectedChat.messages.map((item, index) => {
                            return (
                              <ChatMessage
                                key={index}
                                sender={item.sender}
                                item={item}
                                avatar={
                                  selectedChat.channel === 'PhoneSuite'
                                    ? bot_icon
                                    : selectedChat.avatar
                                }
                                colors={selectedChat.colours}
                              />
                            );
                          })}
                      </div>
                    ) : (
                      // </PerfectScrollbar>
                      this.state.isFilterGet && (
                        <div className="text-center no-conversation">
                          <p>
                            No data found. Please select a different date range
                            from <b>Show Filters</b>
                          </p>
                        </div>
                      )
                    )}
                  </div>
                </CardBody>
              </Card>
            </Colxx>
          </Row>
          <Validation
            open={this.state.open}
            messages={this.state.msg}
            toggle={() => {
              this.setState({ open: false });
            }}
          ></Validation>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ chatListApp, usersListApp, settings }) => {
  const { propertyId, timeZone, locale, email } = settings;
  return {
    chatListApp,
    usersListApp,
    propertyId,
    timeZone,
    locale,
    email,
  };
};

export default injectIntl(
  connect(mapStateToProps, {
    getChatList,
    getChatListSearch,
    getChat,
    getPropertyList,
    createTicket,
  })(Conversations)
);
